import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-badgeå¾½æ 
 * 
 * å¾æ å³ä¸è§çåå½¢å¾½æ æ°å­ã
 * 
 * ä¸è¬åºç°å¨éç¥å¾æ æå¤´åçå³ä¸è§ï¼ç¨äºæ¾ç¤ºéè¦å¤ççæ¶æ¯æ¡æ°ï¼éè¿éç®è§è§å½¢å¼å¸å¼ç¨æ·å¤çã
 * 
 */
@Component({
    selector: 'fc-badge',
    template: `
     <nz-badge [nzPlacement]="fcPosition" [title]="fcToolTip" [nzCount]="_count" [nzOverflowCount]="_overflowCount" *ngIf="fcCount!==undefined"> 
        <ng-content select="[fccontent]"></ng-content>
        <i class="icon iconfont  {{fcIcon}}" [style.fontSize]="fcFontSize" [ngClass]="{'fc-icon-small':fcSize === 'small','fc-icon-default':fcSize === 'default','fc-icon-large':fcSize === 'large'}" ></i>
     </nz-badge>
    <nz-badge [nzDot]="_dot" *ngIf="fcDot==='Y'">
        <ng-content select="[fccontent]"></ng-content>
        <i class="icon iconfont  {{fcIcon}}" [style.fontSize]="fcFontSize" [ngClass]="{'fc-icon-small':fcSize === 'small','fc-icon-default':fcSize === 'default','fc-icon-large':fcSize === 'large'}" ></i>
    </nz-badge>
    <nz-badge [nzStatus]="fcStatus" [nzText]="fcText" *ngIf="fcStatus!==undefined&&fcCount===undefined&&fcDot===undefined"></nz-badge>
    `,
    styles: [`
    `]
})
export class FcbadgeComponent extends FcinputComponent {
     /** æç¤ºæ é¢*/
    @Input()
    fcToolTip: string;
     /** æç¤ºæ é¢ä½ç½®*/
    @Input()
    fcPosition: string;
     /** å±ç¤ºå°é¡¶çæ°å­*/
    @Input()
    fcOverflowCount: string;
    _overflowCount:number;
     /** å¾½æ æ°å­*/
    @Input()
    fcCount: string;
    _count: number[];
     /** ç¶æå¼é¢è²åºå«*/
    @Input()
    fcStatus: string;
     /** ææ¬åå®¹å¤´å*/
    @Input()
    fcText: string;
     /**å¾æ */
    @Input()
    fcIcon: string;
     /**å°çº¢ç¹*/
    @Input()
    fcDot: string;
    _dot:boolean;
     /**æç¤ºé¢æ¿*/
    @Input()
    fcContent:string;
    @Input()
    fcFontSize:string;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-badge');
        this._count = [0];
         /**æç¤ºæ é¢çä½ç½®é»è®¤å¨åºé¨*/
        if (this.fcPosition === undefined) {
            this.fcPosition = "bottom";
        }
         /**å°é¡¶æ°å­é»è®¤ä¸º99*/
        if (this.fcOverflowCount === undefined) {
            this.fcOverflowCount = '99';
        }
         /**ç¶æé»è®¤æªdefault*/
        if (this.fcStatus === undefined) {
            this.fcStatus = "default";
        }
         /**è®¨å«çå°åç¹é»è®¤ä¸å¼å¯*/
        if(this.fcDot === undefined){
            this._dot = false;
        }
    }
    _afterParentInit() {
         /**å¾½æ å­ç¬¦ä¸²è½¬ænumberç±»å*/
        if (this.fcCount) {
            this._count[0] = Number(this.fcCount);
        }
         /**å°é¡¶æ°å­å­ç¬¦ä¸²è½¬number*/
        if (this.fcOverflowCount) {
            this._overflowCount= parseInt(this.fcOverflowCount);
        }
         /**è®¨å«çå°åç¹ä¸ºYæ¶å¼å¯*/
        if(this.fcDot == 'Y'){
            this._dot = true;
        }
    }
    
}
